// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function AddAnotherRule(props) {
  return (
    <div
      className="tempworkflow-addrule-btn"
      onKeyPress={() => null}
      role="button"
      tabIndex="0"
      onClick={props.addRuleToWorkflow}>
      <i>
        <FontAwesomeIcon icon={["far", "plus-circle"]} />
      </i>
      Add another rule
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Template/TempWorkFlow/AddAnotherRule/AddAnotherRule.js